// Klaviyo Integration - Form submission tracking via AJAX interception
(function () {
  // Ensure _learnq is available
  globalThis._learnq = window._learnq || [];

  // Store original fetch
  let originalFetch = globalThis.fetch;

  // Override fetch to intercept Forms App submissions
  globalThis.fetch = function (...args) {
    let url = args[0];
    let options = args[1] || {};

    // Check if this is a Forms App submission
    if (typeof url === 'string' && url.includes('forms.shopifyapps.com/api/v2/form_submission')) {
      console.log('🔍 Intercepted Forms App submission');

      // Get request body
      let requestBody = null;
      if (options.body) {
        if (typeof options.body === 'string') {
          try {
            requestBody = JSON.parse(options.body);
          } catch (e) {
            console.warn('Could not parse request body:', e);
          }
        } else if (options.body instanceof FormData) {
          // Handle FormData if needed
          requestBody = {};
          for (let pair of options.body.entries()) {
            requestBody[pair[0]] = pair[1];
          }
        } else {
          requestBody = options.body;
        }
      }

      // Extract data and send to Klaviyo
      if (requestBody) {
        let email = requestBody.email;
        let interests =
          requestBody['custom#future_products_interest'] ||
          requestBody['future_products_interest'] ||
          requestBody.custom?.future_products_interest;
        let country_for_delivery =
          requestBody['custom#country_for_delivery'] ||
          requestBody['country_for_delivery'] ||
          requestBody.custom?.country_for_delivery;

        if (email) {
          let interestsString = '';
          if (Array.isArray(interests)) {
            interestsString = interests.join(', ');
          } else if (interests) {
            interestsString = interests;
          }

          let klaviyoData = {
            $email: email,
          };

          if (interestsString) {
            klaviyoData.future_products_interest = interestsString;
          }

          if (country_for_delivery) {
            klaviyoData.country_for_delivery = country_for_delivery;
          }

          globalThis._learnq.push(['identify', klaviyoData]);
          console.log('✅ Klaviyo: Sent identify', klaviyoData);
        }
      }
    }

    // Call original fetch
    return originalFetch.apply(this, args);
  };

  // Also intercept XMLHttpRequest as fallback
  let originalXHROpen = XMLHttpRequest.prototype.open;
  let originalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._url = url;
    this._method = method;
    return originalXHROpen.apply(this, [method, url, ...rest]);
  };

  XMLHttpRequest.prototype.send = function (body) {
    let url = this._url;

    if (url?.includes('forms.shopifyapps.com/api/v2/form_submission')) {
      console.log('🔍 Intercepted Forms App submission (XHR)');

      let requestBody = null;
      if (body) {
        if (typeof body === 'string') {
          try {
            requestBody = JSON.parse(body);
          } catch (e) {
            console.warn('Could not parse XHR body:', e);
          }
        } else {
          requestBody = body;
        }
      }

      // Extract data and send to Klaviyo
      if (requestBody) {
        let email = requestBody.email;
        let interests =
          requestBody['custom#future_products_interest'] ||
          requestBody['future_products_interest'] ||
          requestBody.custom?.future_products_interest;
        let country_for_delivery =
          requestBody['custom#country_for_delivery'] ||
          requestBody['country_for_delivery'] ||
          requestBody.custom?.country_for_delivery;

        if (email) {
          let interestsString = '';
          if (Array.isArray(interests)) {
            interestsString = interests.join(', ');
          } else if (interests) {
            interestsString = interests;
          }

          let klaviyoData = {
            $email: email,
          };

          if (interestsString) {
            klaviyoData.future_products_interest = interestsString;
          }

          if (country_for_delivery) {
            klaviyoData.country_for_delivery = country_for_delivery;
          }

          globalThis._learnq.push(['identify', klaviyoData]);
          console.log('✅ Klaviyo: Sent identify (XHR)', klaviyoData);
        }
      }
    }

    return originalXHRSend.apply(this, arguments);
  };
})();
